<template>
  <div class="switch-wrap" :class="{ active: switchActive }" @click="handleSwitch">
    <div class="switch-node"></div>
  </div>
</template>

<script>
// import导入组件工具等
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      switchActive: this.value,
    }
  },
  created() {
    this.switchActive = this.value
  },
  // 组件方法
  methods: {
    handleSwitch() {
      this.switchActive = !this.switchActive
      this.$emit('input', this.switchActive)
      this.$emit('change', this.switchActive)
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // import的组件需要声明
  components: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.switch-wrap {
  width: 52px;
  height: 26px;
  border-radius: 13px;
  position: relative;
  background-color: rgba(162, 169, 176, 1);
  cursor: pointer;
  transition: background-color 0.2s;
  &.active {
    background-color: rgba(27, 194, 99, 1);
    .switch-node {
      transform: translateX(26px);
    }
  }
  .switch-node {
    width: 22px;
    height: 22px;
    position: absolute;
    left: 2px;
    top: 2px;
    border-radius: 50%;
    background-color: #fff;
    transition: all 0.2s;
  }
}
</style>
